import * as React from "react";

function WatsApp(props) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <title>{"Icons/Whatsapp@0.5x"}</title>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}>
        <g>
          <rect width={24} height={24} x={0} y={0} />
          <g fillRule="nonzero" transform="translate(5.000000, 5.000000)">
            <path
              fill="#ECEFF1"
              d="M11.9698464,2.01192101 C10.6398635,0.726250726 8.88988596,0 7.02615987,0 C1.67705949,0 -1.68172843,5.7954318 0.989318309,10.4054964 L0,14 L3.69537159,13.036379 C5.30535094,13.9061299 6.62422502,13.8291298 7.02965982,13.8804399 C13.2321403,13.8804399 16.3197306,6.37643238 11.9610966,2.03467103 L11.9698464,2.01192101 Z"
            />
            <path
              fill="#4CAF50"
              d="M7.0003763,13 L6.99675324,12.9994178 L6.9871159,12.9994178 C5.06567611,12.9994178 3.83806703,12.0854322 3.71729591,12.0326658 L1.45288265,12.6240126 L2.0597454,10.4132854 L1.91542438,10.1858444 C1.31761928,9.22993685 1,8.12912208 1,6.9955558 C1,1.66254674 7.48833019,-1.00427584 11.242981,2.76518104 C14.9886466,6.49518545 12.3588838,13 7.0003763,13 Z"
            />
            <path
              fill="#FAFAFA"
              d="M10.6463874,7.96919194 L10.6411996,8.0160437 C10.4676532,7.92234019 9.62267806,7.47443744 9.46531734,7.41259313 C9.11193013,7.2707635 9.21167262,7.39010429 8.5332577,8.23216146 C8.43233933,8.35397602 8.33204349,8.36334637 8.16084886,8.27901321 C7.987925,8.18530971 7.43283938,7.98853235 6.77572869,7.35134852 C6.26387405,6.85471994 5.92036424,6.24564717 5.81891327,6.05824016 C5.6500289,5.74212202 6.0033677,5.69714433 6.32501993,5.03747166 C6.38263816,4.90632424 6.3532411,4.80325038 6.31056349,4.71016907 C6.26733252,4.61646556 5.92324861,3.69817122 5.77914078,3.33210536 C5.64080169,2.96728389 5.49843001,3.01351345 5.39179132,3.01351345 C5.0597775,2.98227645 4.81710997,2.98727647 4.60325849,3.22840182 C3.67292809,4.33660693 3.90753044,5.4797522 4.70355433,6.69542399 C6.26795505,8.91432297 7.10144809,9.32287025 8.62546071,9.89011379 C9.03701951,10.0318684 9.4122643,10.0119283 9.70913999,9.96567629 C10.0399779,9.90885449 10.7276616,9.51529977 10.8711884,9.0748933 C11.0181737,8.63448683 11.0181737,8.26904316 10.9749427,8.18471001 C10.9322651,8.10037685 10.8193112,8.0535251 10.6463874,7.96919194 L10.6463874,7.96919194 Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default WatsApp;
